import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import { AuthSignupForm } from 'forms';
import { FormWrapper, TopBorderPaper } from 'components';

interface AuthSignupPageProps {}

export const AuthSignupPage: React.FC<AuthSignupPageProps> = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get('token') as string;
  const email = new URLSearchParams(search).get('email') as string;
  const organization_id = Number(new URLSearchParams(search).get('organization_id') as string);
  const role = Number(new URLSearchParams(search).get('role') as string);

  return (
    <Box
      sx={{
        paddingX: 2,
        paddingTop: 3,
        paddingBottom: 8,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: 3,
        }}
      />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          minHeight: 400,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: (theme) => theme.breakpoints.values.sm,
            position: 'relative',
          }}
        >
          <TopBorderPaper>
            <FormWrapper>
              <Typography
                variant="h5"
                sx={{
                  marginBottom: 1,
                }}
              >
                Sign in to get started
              </Typography>

              <Typography
                color="textSecondary"
                variant="body2"
                sx={{
                  lineHeight: 1.5,
                  marginBottom: 6,
                }}
              >
                Login to your new account below
              </Typography>

              <AuthSignupForm token={token} email={email} organization_id={organization_id} role={role} />
            </FormWrapper>
          </TopBorderPaper>
        </Box>
      </Box>
    </Box>
  );
};
